var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMainPetCake(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_67_3362)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3.7085,
    y: 21.8028,
    width: 26.083,
    height: 10.6706,
    fill: "#FF965B",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.25,
    y: 32.55,
    width: 31,
    height: 2.6,
    rx: 1.3,
    fill: "#FF5B5B",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4807 7.90204C14.4807 7.34975 14.9284 6.90204 15.4807 6.90204H18.3481C18.9004 6.90204 19.3481 7.34975 19.3481 7.90204V12.3185H14.4807V7.90204Z",
    fill: "#FF5B5B",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4044 3.30874L15.4045 3.30865L16.8005 0.915951C16.8006 0.915813 16.8007 0.915675 16.8007 0.915538C16.8258 0.873225 16.8672 0.849976 16.9144 0.849976C16.9617 0.849976 17.0031 0.873231 17.0281 0.915555C17.0282 0.915687 17.0283 0.915819 17.0284 0.915951L18.4235 3.30718C18.5957 3.60722 18.6855 3.94174 18.6855 4.28493V4.44415C18.6855 5.4254 17.8924 6.21868 16.9144 6.21868C15.9365 6.21868 15.1433 5.4254 15.1433 4.44415V4.28493C15.1433 3.93948 15.2343 3.60027 15.4044 3.30874Z",
    fill: "#F9F29D",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.7334,
    y: 14.2333,
    width: 16.033,
    height: 6.90808,
    fill: "#FF965B",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96743 12.1946C11.2077 11.9155 19.6572 12.0783 23.727 12.1946C26.4013 12.7372 27.1378 15.7605 25.82 16.2256C24.5022 16.6907 24.6185 15.2954 23.3394 15.1791C22.0603 15.0628 21.5565 16.3031 19.8898 16.4969C18.2232 16.6907 17.7584 15.1016 16.1693 15.7992C14.5802 16.4969 15.3554 18.7062 13.572 18.7062C11.3244 18.7062 13.3399 16.2256 10.8976 15.5279C9.62284 15.1638 8.99893 17.6984 7.68066 16.7295C5.83704 15.3743 8.41709 12.5434 9.96743 12.1946Z",
    fill: "#FEF1AD",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.69378 20.7419H29.0966C31.9401 21.3785 32.6615 24.9859 30.7093 25.7074C28.7571 26.4288 28.8373 24.0088 27.2996 24.7185C26.1961 25.2278 27.0152 26.344 26.3787 27.2352C25.7421 28.1264 24.2567 28.5933 23.4928 27.2352C22.7289 25.8771 22.9514 24.8088 20.6087 24.4766C18.266 24.1444 18.317 26.1742 16.9165 26.2166C15.516 26.2591 14.6672 24.7737 13.1393 24.4766C11.6115 24.1796 11.1022 25.962 9.44711 25.962C7.79197 25.962 7.02806 24.7737 5.79732 24.4766C4.56657 24.1796 4.69378 25.7074 3.16601 25.962C-0.263093 24.1626 3.16585 20.7419 4.69378 20.7419Z",
    fill: "#FEF1AD",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4551 28.2645C11.4548 27.9179 11.6448 27.2247 12.4072 27.2247C13.1697 27.2247 13.3892 27.9179 13.4036 28.2645",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0962 28.2645C20.0959 27.9179 20.2859 27.2247 21.0483 27.2247C21.8108 27.2247 22.0303 27.9179 22.0447 28.2645",
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.2485,
    cy: 30.0555,
    rx: 2.15527,
    ry: 1.58807,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.2515,
    cy: 30.0555,
    rx: 2.15527,
    ry: 1.58807,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8401 28.9358C18.8401 30.156 17.5616 31.1452 16.7499 31.1452C15.9382 31.1452 14.6597 30.156 14.6597 28.9358C14.6597 27.7156 15.5955 27.1381 16.7499 27.1381C17.9043 27.1381 18.8401 27.7156 18.8401 28.9358Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_67_3362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 36,
    fill: "white",
    transform: "translate(0.75)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMainPetCake);
export default __webpack_public_path__ + "static/media/icon-main-pet-cake.c5eaf21b731dae005e9fdb50634a80d9.svg";
export { ForwardRef as ReactComponent };